import * as React from "react";
import Container from "components/Container";
import CreateAccountModal from "components/CreateAccountModal";
import { withMainLayout } from "layout/withMainLayout";

import styles from "./styles.module.scss";

import HeroBackground from "assets/img-sunwin/bg-casino-girl.png";
import HeroOverlay from "assets/img-sunwin/bg-after.png";
import LogoSunwin from "assets/img-sunwin/logo.png";
import SloganSunwin from "assets/img-sunwin/slogan.png";
import BtnApk from "assets/img-sunwin/btn-apk.png";
import BtnWebMobile from "assets/img-sunwin/btn-playweb-mb.png";
import BtnCreateAccount from "assets/img-sunwin/btn-taotaikhoan-mb.png";
import SliderIconCheck from "assets/img-sunwin/icon-checkdone.png";
import SliderIconGem from "assets/img-sunwin/logo-ncc-gem.png";
import SliderIconDownload from "assets/img-sunwin/icon-arrow-down.png";
import SliderPrev from "assets/img-sunwin/icon-prew-ncc.png";
import SliderNext from "assets/img-sunwin/icon-next-ncc.png";
import PhoneFrame from "assets/img-sunwin/bg-content-games.webp";
import FooterBadge from "assets/img-sunwin/logo.png";
import FooterDmca from "assets/img-sunwin/chungnhan.png";
import FooterSupportBtn from "assets/img-sunwin/btn-hotro.png";
import SocialFacebook from "assets/img-sunwin/socials/icon-facebook-mb.png";
import SocialTelegram from "assets/img-sunwin/socials/icon-telegram-mb.png";
import SocialChat from "assets/img-sunwin/socials/icon-chat-mb.png";
import Game1 from "assets/img-sunwin/ct-game/ctgame1.webp";
import Game2 from "assets/img-sunwin/ct-game/ctgame2.webp";
import Game3 from "assets/img-sunwin/ct-game/ctgame3.webp";
import Game4 from "assets/img-sunwin/ct-game/ctgame4.webp";
import Game5 from "assets/img-sunwin/ct-game/ctgame5.webp";
import Game6 from "assets/img-sunwin/ct-game/ctgame6.webp";

type SliderItem = {
  id: number;
  label: React.ReactNode;
  labelText: string;
  icon: string;
  extraIcon?: string;
};

const SLIDER_ITEMS: SliderItem[] = [
  {
    id: 0,
    labelText: "GEMWIN.VIP - Đối tác tin cậy",
    label: "GEMWIN.VIP - Đối tác tin cậy",
    icon: SliderIconGem,
    extraIcon: SliderIconDownload,
  },
  {
    id: 1,
    labelText: "Cách phân biệt Sun.Win THẬT - GIẢ",
    label: (
      <>
        Cách phân biệt Sun.Win{" "}
        <span className={styles.green}>THẬT</span> -{" "}
        <span className={styles.red}>GIẢ</span>
      </>
    ),
    icon: SliderIconCheck,
  },
];

const SOCIAL_LINKS = [
  { id: "facebook", icon: SocialFacebook, alt: "Facebook" },
  { id: "telegram", icon: SocialTelegram, alt: "Telegram" },
  { id: "chat", icon: SocialChat, alt: "Chat" },
];

const GAME_IMAGES = [Game1, Game2, Game3, Game4, Game5, Game6];
const GAME_TRACK = [...GAME_IMAGES, ...GAME_IMAGES];
const INTERCOM_APP_ID = "snx821c4";

type IntercomModule = typeof import("@intercom/messenger-js-sdk");

const Home: React.FunctionComponent = () => {
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [isCreateAccountModalOpen, setIsCreateAccountModalOpen] = React.useState(false);
  const intercomModuleRef = React.useRef<Promise<IntercomModule | null> | null>(null);

  const loadIntercom = React.useCallback(() => {
    if (typeof window === "undefined") {
      return Promise.resolve(null);
    }

    if (!intercomModuleRef.current) {
      intercomModuleRef.current = import("@intercom/messenger-js-sdk")
        .then((module) => {
          module.default({
            app_id: INTERCOM_APP_ID,
          });
          return module;
        })
        .catch((error) => {
          console.error("Failed to load Intercom messenger", error);
          intercomModuleRef.current = null;
          return null;
        });
    }

    return intercomModuleRef.current;
  }, []);

  React.useEffect(() => {
    loadIntercom();
  }, [loadIntercom]);

  const handleIntercomShow = React.useCallback(() => {
    loadIntercom().then((module) => {
      module?.show();
    });
  }, [loadIntercom]);

  const handleNavigate = React.useCallback((url: string, target: "_self" | "_blank" = "_self") => {
    if (typeof window === "undefined") {
      return;
    }

    if (target === "_blank") {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }

    window.location.href = url;
  }, []);

  const handleNext = React.useCallback(() => {
    setActiveSlide((prev) => (prev + 1) % SLIDER_ITEMS.length);
  }, []);

  const handlePrev = React.useCallback(() => {
    setActiveSlide((prev) =>
      (prev - 1 + SLIDER_ITEMS.length) % SLIDER_ITEMS.length
    );
  }, []);

  React.useEffect(() => {
    const timer = window.setInterval(handleNext, 5000);
    return () => window.clearInterval(timer);
  }, [handleNext]);

  const currentSlide = SLIDER_ITEMS[activeSlide];

  const handleOpenCreateAccount = React.useCallback(() => {
    setIsCreateAccountModalOpen(true);
  }, []);

  const handleCloseCreateAccount = React.useCallback(() => {
    setIsCreateAccountModalOpen(false);
  }, []);

  return (
    <div className={styles.home}>
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${HeroBackground})` }}
      >
        <img className={styles.heroOverlay} src={HeroOverlay} alt="" />

        <Container className={styles.heroContainer}>
          <div className={styles.heroContent}>
            <img className={styles.logoSunwin} src={LogoSunwin} alt="Sun.win" />
            <img
              className={styles.sloganSunwin}
              src={SloganSunwin}
              alt="Sun.win - Uy tín tạo khác biệt"
            />

            <div className={styles.ctaGroup}>
              <button
                type="button"
                className={styles.ctaButtonPrimary}
                onClick={() => handleNavigate("https://s.n11s.io/apk/lobby10/lobby10-20250922.apk", "_blank")}
              >
                <img src={BtnApk} alt="Cài đặt Apk" />
              </button>
              <div className={styles.apkNotice}>
                <span>Bản Google Play hiện đang được nâng cấp</span>
                <a href="#" className={styles.apkGuide}>
                  Hướng dẫn tải APK
                </a>
              </div>

              <button
                type="button"
                className={styles.ctaButton}
                onClick={() => handleNavigate("http://lobby10.n11s.io/")}
              >
                <img src={BtnWebMobile} alt="Truy Cập Web Mobile" />
              </button>
              <button
                type="button"
                className={styles.ctaButton}
                onClick={handleOpenCreateAccount}
              >
                <img src={BtnCreateAccount} alt="Tạo tài khoản" />
              </button>
            </div>

            <div className={styles.sliderArea}>
              <button type="button" className={styles.sliderNav} onClick={handlePrev}>
                <img src={SliderPrev} alt="Previous" />
              </button>

              <div className={styles.sliderItem}>
                <img className={styles.sliderIcon} src={currentSlide.icon} alt={currentSlide.labelText} />
                <span className={styles.label}>{currentSlide.label}</span>

                {currentSlide.extraIcon && (
                  <img
                    className={styles.extraIcon}
                    src={currentSlide.extraIcon}
                    alt=""
                    aria-hidden="true"
                  />
                )}
              </div>


              <button type="button" className={styles.sliderNav} onClick={handleNext}>
                <img src={SliderNext} alt="Next" />
              </button>
            </div>

            <div className={styles.sliderDots}>
              {SLIDER_ITEMS.map((item, index) => (
                <span
                  key={item.id}
                  className={index === activeSlide ? styles.dotActive : styles.dot}
                />
              ))}
            </div>
          </div>
        </Container>

        <div className={styles.heroSocials}>
          {SOCIAL_LINKS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={item.id === "chat" ? handleIntercomShow : undefined}
            >
              <img src={item.icon} alt={item.alt} />
            </button>
          ))}
        </div>
      </section>

      <section className={styles.introSection}>
        <Container className={styles.introContainer}>
          <h2>SUNWIN - CỔNG GAME ĐỔI THƯỞNG UY TÍN #1 | TẢI NGAY!</h2>
          <p>
            Nếu bạn đang tìm kiếm một cổng game đổi thưởng uy tín, Sunwin chính
            là sự lựa chọn hàng đầu cho bạn. Với giao diện thân thiện và hệ
            thống bảo mật nghiêm ngặt, Sunwin giúp bạn giao lưu và trải nghiệm
            các tựa game một cách an toàn. Tại đây, bạn còn có thể trải nghiệm
            các siêu phẩm hấp dẫn: Tài xỉu, nổ hũ và nhiều mini game giải trí
            khác. Đừng bỏ lỡ những khuyến mãi hấp dẫn và cơ hội nhận thưởng mỗi
            ngày từ Sunwin!
          </p>

          <div className={styles.phoneWrapper}>
            <div className={styles.phoneFrame}>
              <img src={PhoneFrame} alt="Sunwin games" />
              <div className={styles.phoneScreen}>
                <div className={styles.gameTrack}>
                  {GAME_TRACK.map((src, index) => (
                    <img
                      key={`${src}-${index}`}
                      src={src}
                      alt={`Game ${index % GAME_IMAGES.length + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.infoCard}>
            <h3>Ứng dụng cá cược tương thích với mọi hệ điều hành</h3>
            <p>
              Ứng dụng Sunwin đã có sẵn trên kho ứng dụng của cả hai hệ điều
              hành là iOS và Android. Ưu điểm lớn nhất của app cá cược là dung
              lượng vô cùng nhẹ nên người dùng có thể tải và sử dụng một cách
              nhanh gọn. Hệ thống bảo mật tại ứng dụng cũng nghiêm ngặt và chặt
              chẽ không thua kém gì người chơi cá cược trên website cổng game.
            </p>
            <p>
              Trải nghiệm cá cược tại app Sunwin sẽ không có nhiều điểm khác
              biệt so với bạn truy cập website, người chơi có thể đăng nhập, nạp
              tiền và rút tiền nhanh chóng. Bộ phận chăm sóc khách hàng 24/7 sẽ
              giúp bạn giải đáp mọi thắc mắc nhanh chóng để bạn có thể tận
              hưởng những phút giây giải trí tuyệt vời. Đặc biệt, hệ thống bảo
              mật hiện đại giúp thông tin cá nhân và tài khoản của bạn luôn được
              bảo vệ an toàn tuyệt đối.
            </p>
          </div>
        </Container>
      </section>

      <footer className={styles.footer}>
        <Container className={styles.footerContainer}>
          <div className={styles.footerMain}>
            <div className={styles.footerBrand}>
              <img src={FooterBadge} alt="Sun.win" />
            </div>

            <div className={styles.footerCerts}>
              <span>CHỨNG NHẬN</span>
              <img src={FooterDmca} alt="DMCA" />
            </div>

            <div className={styles.footerSocials}>
              <span>THEO DÕI CHÚNG TÔI</span>
              <div>
                {SOCIAL_LINKS.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    onClick={item.id === "chat" ? handleIntercomShow : undefined}
                  >
                    <img src={item.icon} alt={item.alt} />
                  </button>
                ))}
              </div>
            </div>

            <button
              type="button"
              className={styles.footerSupport}
              onClick={handleIntercomShow}
            >
              <img src={FooterSupportBtn} alt="Hỗ trợ trực tuyến 24/7" />
            </button>
          </div>

          <div className={styles.footerLegal}>
            <p>
              All the copyrighted content on this website, including text,
              images, graphics, and other materials, is the intellectual property
              of Sunwin Information Technology LLC. Unauthorized use,
              duplication, reproduction, modification, distribution, publication,
              transmission, or any other form of copying is strictly prohibited.
            </p>
            <p>
              © 2018-2025 Sunwin Information Technology LLC. All rights
              reserved.
            </p>
          </div>
        </Container>
      </footer>
      <CreateAccountModal
        isOpen={isCreateAccountModalOpen}
        onClose={handleCloseCreateAccount}
      />
    </div>
  );
};

export default withMainLayout(Home, { hideHeader: true, hideFooter: true });
